// extracted by mini-css-extract-plugin
export default {"containerTitle":"CategoryTitle_containerTitle__gmQQz"};